/* Copyright (c) 2026 Xperi. All Rights Reserved. */

const SEGMENT_RETRY_PARAMETERS = {
  maxAttempts: 4,
  baseDelay: 500,
  backoffFactor: 2,
  fuzzFactor: 0.5,
  timeout: 60000,
  stallTimeout: 15000,
  connectionTimeout: 15000
};

const CONTROL_RETRY_PARAMETERS = {
  maxAttempts: 3,
  baseDelay: 500,
  backoffFactor: 2,
  fuzzFactor: 0.5,
  timeout: 30000,
  stallTimeout: 10000,
  connectionTimeout: 15000
};

export const TIMING_RETRY_OVERRIDES = {
  timeout: 5000,
  stallTimeout: 3000,
  connectionTimeout: 3000
};

/**
 * Default Shaka Player configuration optimized for Smart TV playback.
 * Applied once during player setup via shaka.Player.configure().
 * Individual properties may be overridden via IPlayer.configure().
 */
export const SHAKA_PLAYER_CONFIG = {
  // Prefer AAC (decoded to PCM on the device) over Dolby AC-3/E-AC-3. On Vega
  // OS with Surround Sound = "Best Available", Dolby audio is sent as HDMI
  // passthrough, which cannot be mixed with VoiceView speech (VoiceView goes
  // silent during playback). Linear channels carry HE-AAC (mp4a.40.5), which
  // the previous LC-only entry ("mp4a.40.2") did not match, so Shaka fell back
  // to the AC-3 adaptation set. Order = preference: AAC-LC, HE-AAC, HE-AACv2.
  preferredAudioCodecs: ["mp4a.40.2", "mp4a.40.5", "mp4a.40.29"],
  preferredTextLanguage: "",
  preferredTextRole: "",
  drm: {
    retryParameters: CONTROL_RETRY_PARAMETERS
  },
  networking: {
    minBytesForProgressEvents: 16000
  },
  streaming: {
    retryParameters: SEGMENT_RETRY_PARAMETERS,
    loadTimeout: 70,
    inaccurateManifestTolerance: 1,
    rebufferingGoal: 1,
    bufferBehind: 6,
    bufferingGoal: 18,
    stallSkip: 0.1,
    startAtSegmentBoundary: false,
    segmentPrefetchLimit: 1,
    lowLatencyMode: true
  },
  manifest: {
    retryParameters: CONTROL_RETRY_PARAMETERS,
    defaultPresentationDelay: 10,
    hls: {
      ignoreTextStreamFailures: true,
      ignoreImageStreamFailures: true
    },
    dash: {
      ignoreMinBufferTime: true,
      clockSyncUri: "https://time.akamai.com",
      ignoreEmptyAdaptationSet: true
    }
  },
  abr: {
    enabled: true,
    defaultBandwidthEstimate: 230000,
    switchInterval: 6
  }
};
